/**
 * Format city and state into a location string
 */
export function formatLocation(city?: string | null, state?: string | null): string {
  return [city, state].filter(Boolean).join(", ")
}
